// extracted by mini-css-extract-plugin
export var btn = "main-module--btn--c1c50";
export var consultBtn = "main-module--consult-btn--4143a";
export var title = "main-module--title--d025f";